var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeatMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 1.13192C8.4375 0.202158 7.24012 -0.147959 6.71293 0.622626C1.875 7.69414 8.75 8.01246 8.75 11.45C8.75 12.8417 7.61273 13.9678 6.2168 13.9497C4.84297 13.9319 3.75 12.7867 3.75 11.4127V8.07246C3.75 7.22469 2.71598 6.81367 2.13156 7.42778C1.08598 8.52645 0 10.4082 0 12.7C0 16.8355 3.36449 20.2 7.5 20.2C11.6355 20.2 15 16.8355 15 12.7C15 6.04801 8.4375 5.16079 8.4375 1.13192V1.13192Z",
    fill: "url(#paint0_linear_613_716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_613_716",
    x1: 7.5,
    y1: 0.199951,
    x2: 7.5,
    y2: 20.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#E8AA07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BC597"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatMap);
export default __webpack_public_path__ + "static/media/heatMap.af2c32008a5e2eeb5a30759be2e1ee61.svg";
export { ForwardRef as ReactComponent };